import styled from '@emotion/styled';

import { colors, fontWeight } from '@datacamp/waffles-tokens';

export const Wrapper = styled.nav`
  margin-top: 32px;
  align-items: center;
  display: flex;
`;

export const Link = styled.a`
  flex-shrink: 0 !important;
  border-bottom: 0;
  font-weight: ${fontWeight.normal};
  background: ${colors.primary};
  border-radius: 50%;
  color: ${colors.white};
  height: 48px;
  justify-content: center;
  text-align: center;
  width: 48px;
  align-items: center;
  display: flex;

  &:not(:first-of-type) {
    margin-left: 16px;
  }
`;

export const Icon = styled.span`
  height: 18px;
  width: 18px;
  fill: ${colors.white};
  top: 0;
  display: inline-block;
  flex-shrink: 0;
  overflow: hidden;
  position: relative;
  transition: fill 0.3s cubic-bezier(0.77, 0, 0.175, 1);
  vertical-align: middle;
`;
